<template>
  <div class="">
    <div class="content">
      <div class="title">基本信息</div>
      <div class="base clearfix">
        <div class="item">
          <div class="label">产品名称</div>
          <div class="value">{{ detailInfo.productCode }}/{{ detailInfo.productName }}</div>
        </div>
        <div class="item">
          <div class="label">订单号</div>
          <div class="value">{{ detailInfo.orderNo }}</div>
        </div>
        <div class="item">
          <div class="label">保单号</div>
          <div class="value">{{ detailInfo.policyNo }}</div>
        </div>
        <div class="item">
          <div class="label">保险期间</div>
          <div class="value">{{ detailInfo.startTime | cutString(10) }} 至 {{ detailInfo.endTime | cutString(10) }}</div>
        </div>
        <div v-if="$units.pointAction('order_50_2') && detailInfo.policyUrl" class="item">
          <div class="label">电子保单</div>
          <div class="value">
            <a :href="detailInfo.policyUrl">
              <Button type="primary">下载电子保单</Button>
            </a>
          </div>
        </div>
        <div class="item">
          <div class="label">保险公司</div>
          <div class="value">{{ detailInfo.companyName }}</div>
        </div>
        <div class="item">
          <div class="label">业务类别</div>
          <div class="value">{{ detailInfo.sellType }}</div>
        </div>
        <div class="item" v-if="$units.superviseShowVal()">
          <div class="label">业务来源</div>
          <div class="value">{{ detailInfo.businessSource == 1 ? '直营' : '分销' }}</div>
        </div>
        <div class="item">
          <div class="label">出单保费</div>
          <div class="value">{{ detailInfo.fee | number_format(2) }}元</div>
        </div>
        <div class="item">
          <div class="label">出单业务员</div>
          <div class="value">{{ detailInfo.salemanName }}</div>
        </div>
        <div class="item">
          <div class="label">所属团队</div>
          <div class="value">{{ detailInfo.groupName }}</div>
        </div>
        <div class="item">
          <div class="label">所属机构</div>
          <div class="value">{{ detailInfo.organizationName }}</div>
        </div>
        <div class="item">
          <div class="label">保单状态</div>
          <div class="value">{{ statusMap[detailInfo.status] }}</div>
        </div>
        <template v-if="detailInfo.status == '-1'">
          <Divider />
          <div class="descLine"></div>
          <div class="item">
            <div class="label">退费金额</div>
            <div class="value">{{ detailInfo.refundFee | number_format(2) }}元</div>
          </div>
          <div class="item">
            <div class="label">退保生效时间</div>
            <div class="value">{{ detailInfo.refundStartTime | cutString(16) }}</div>
          </div>
          <div class="item">
            <div class="label">退保类型</div>
            <div class="value">{{ refundTypeMap[detailInfo.refundType] }}</div>
          </div>
          <div class="item">
            <div class="label">预估扣减服务费</div>
            <div class="value">{{ detailInfo.reduceCommission | number_format(2) }}元</div>
          </div>
        </template>
      </div>
      <div class="title">投保人信息</div>
      <div class="base clearfix">
        <div class="item">
          <div class="label">投保人名称</div>
          <div class="value">{{ detailInfo.holderName }}</div>
        </div>
        <div class="item">
          <div class="label">投保人证件号</div>
          <div class="value">
            <span v-if="!detailInfo.eyeShow1">{{ detailInfo.holderCardNoMask }}</span>
            <span v-else>{{ detailInfo.holderCardNoMask1 }}</span>
            <span v-if="detailInfo.holderCardNoMask">
              <i class="iconfont iconxianshi eye-icon" v-if="detailInfo.eyeShow1" @click="openEye(detailInfo, 'eyeShow1', 'holderCardNoMask', 1)"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(detailInfo, 'eyeShow1', 'holderCardNoMask', 1)"></i>
            </span>
          </div>
        </div>
        <div class="item">
          <div class="label">投保人地址</div>
          <div class="value">
            <span v-if="!detailInfo.eyeShow2">{{ detailInfo.holderAddress }}</span>
            <span v-else>{{ detailInfo.holderAddress1 }}</span>
            <span v-if="detailInfo.holderAddress">
              <i class="iconfont iconxianshi eye-icon" v-if="detailInfo.eyeShow2" @click="openEye(detailInfo, 'eyeShow2', 'holderAddress', 5)"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(detailInfo, 'eyeShow2', 'holderAddress', 5)"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  components: {},
  props: ['id', 'operationFunction'],
  mixins: [common],
  data() {
    return {
      tabVal: '1',
      statusMap: {
        '-1': '退保',
        '0': '终止',
        '1': '保障中'
      },
      refundTypeMap: {
        '1': '生效前退保 ',
        '2': '保障期间退保'
      },
      payTypeMap: {
        '1': '梧桐树代收',
        '2': '保司在线收银台',
        '3': '保司公对公收款'
      },
      detailInfo: {}
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    openEye(item, keyName, name, val) {
      if (!item[keyName]) {
        let params = {
          operationFunction: this.operationFunction || 19,
          operationType: val
        };
        if (item.holderId) {
          params.query = item.holderId;
        }else{
          params.operationFunction = 48;
          params.query = item.policyNo;
          // params.otherInfo = JSON.stringify({policyNo:item.policyNo})
        }
        this.descrypt(params, item, name + '1').then(() => {
          this.$set(item, keyName, true);
        });
      } else {
        this.$set(item, keyName, false);
      }
    },
    getDetail() {
      this.$http({
        url: `/buz/grouppolicy/read/detail`,
        type: 'GET',
        data: { id: this.id }
      }).then(res => {
        this.detailInfo = res.data;
        this.$emit('request-success', res.data);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.tools-box {
  display: flex;
  justify-content: flex-end;
}

.content {
  .title {
    color: #333;
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: bold;

    &::before {
      content: '';
      display: inline-block;
      width: 2px;
      height: 14px;
      background-color: #333;
      margin-right: 10px;
      position: relative;
      top: 2px;
    }
  }

  .base {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 40px;

    .c-red {
      color: #e3461f;
    }

    .item {
      width: 25%;
      display: inline-block;
      flex: 0 0 25%;
      line-height: 3;
      display: flex;
      padding-right: 25px;

      > div {
        &.label {
          flex: 0 0 120px;
          text-align: right;
          &::after {
            content: '：';
          }
        }
        &.value {
          flex-wrap: wrap;
          word-break: break-all;
          word-wrap: break-word;
          display: flex;
        }
        .eye-icon {
          font-size: 14px;
        }
      }
    }
  }

  .descLine {
    border-bottom: 1px solid #eee;
  }
}
</style>
